// front-end/src/components/vacancies-loader/vacancies-loader.js - ИСПРАВЛЕННАЯ ВЕРСИЯ

import { apiGet } from '../../utils/api';
import { isAuthenticated } from '../auth';
import { initSortable } from '../block-system/block-manager/block-sortable';
import { loadContentForNewElements } from '../content-editor-src';
import { createAndTrackBlock } from '../block-system/block-manager/block-renderer';
import { config } from '../../config/app-config';

export class VacanciesLoader {
    constructor() {
        console.log('[VacanciesLoader] Инициализация начата');
        this.currentOffset = 0;
        this.itemsPerPage = 5;
        this.isLoading = false;
        this.hasMoreVacancies = true;
        this.container = null;
        this.loadMoreButton = null;
        this.isAuthenticated = isAuthenticated();
        this.initialized = false;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => this.init(), 100);
            });
        } else {
            setTimeout(() => this.init(), 100);
        }
    }

    init() {
        if (this.initialized) {
            console.log('[VacanciesLoader] Уже инициализирован, пропускаем');
            return;
        }

        console.log('[VacanciesLoader] init() - начало');

        try {
            const { initializeBlockCounters } = require('../block-system/block-manager/block-state');
            initializeBlockCounters();
            console.log('[VacanciesLoader] Счетчики блоков инициализированы');
        } catch (error) {
            console.error('[VacanciesLoader] Ошибка инициализации счетчиков:', error);
        }

        if (window.location.pathname.match(/vacancies(\.html)?$/)) {
            console.log('[VacanciesLoader] Страница vacancies - ищем контейнер');
            this.initElements();
        } else {
            console.log('[VacanciesLoader] Не страница vacancies, пропускаем инициализацию');
        }
    }

    initElements() {
        this.container = document.querySelector('[data-section="vacancies-section"]');
        this.loadMoreButton = document.querySelector('.load-more-');

        console.log('[VacanciesLoader] Контейнер найден:', !!this.container);
        console.log('[VacanciesLoader] Кнопка загрузки найдена:', !!this.loadMoreButton);

        if (this.container) {
            this.initialized = true;
            console.log('[VacanciesLoader] Настраиваем обработчики');

            if (this.container.dataset.ssr === 'true') {
                this.currentOffset = this.container.querySelectorAll('[data-block-name]').length;
                console.log(`[VacanciesLoader] SSR контент обнаружен: ${this.currentOffset} вакансій`);
            } else {
                this.clearContainer();
            }

            if (this.isAuthenticated) {
                initSortable(this.container);
            }

            this.setupLoadMoreButton();

            if (this.container.dataset.ssr !== 'true') {
                this.loadInitialVacancies();
            }
        } else {
            console.warn('[VacanciesLoader] Контейнер vacancies-section не найден!');
        }
    }

    clearContainer() {
        const nonBlockElements = Array.from(this.container.children).filter(
            child => !child.hasAttribute('data-block-name')
        );
        this.container.innerHTML = '';
        nonBlockElements.forEach(element => this.container.appendChild(element));
        console.log('[VacanciesLoader] Контейнер очищен, сохранены не блочные элементы');
    }

    setupLoadMoreButton() {
        if (this.loadMoreButton) {
            const newButton = this.loadMoreButton.cloneNode(true);
            this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
            this.loadMoreButton = newButton;

            this.loadMoreButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('[VacanciesLoader] Кнопка "загрузить больше" нажата');
                this.loadMoreVacancies();
            });

            console.log('[VacanciesLoader] Кнопка "загрузить больше" настроена');
        }
    }

    async loadInitialVacancies() {
        console.log('[VacanciesLoader] loadInitialVacancies() - начало');

        try {
            this.currentOffset = 0;
            this.hasMoreVacancies = true;
            await this.loadVacanciesChunk(0);
        } catch (error) {
            console.error('[VacanciesLoader] Ошибка при загрузке начальных вакансий:', error);
            this.renderErrorState();
        }
    }

    async loadMoreVacancies() {
        if (this.isLoading || !this.hasMoreVacancies) {
            console.log('[VacanciesLoader] Загрузка уже идет или нет больше вакансий');
            return;
        }

        console.log('[VacanciesLoader] loadMoreVacancies() - загружаем еще вакансии');
        console.log(`[VacanciesLoader] Текущий offset: ${this.currentOffset}`);

        try {
            await this.loadVacanciesChunk(this.currentOffset);
        } catch (error) {
            console.error('[VacanciesLoader] Ошибка при загрузке дополнительных вакансий:', error);
            this.showLoadMoreError();
        }
    }

    async loadVacanciesChunk(offset) {
        console.log(`[VacanciesLoader] loadVacanciesChunk() - offset: ${offset}, limit: ${this.itemsPerPage}`);

        this.isLoading = true;
        this.updateLoadMoreButton('loading');

        try {
            // ИСПРАВЛЕНО: Для авторизованных загружаем ВСЕ вакансии, для неавторизованных только published
            let apiUrl = `${config.api.paths.vacanciesOffset}?offset=${offset}&limit=${this.itemsPerPage}`;
            if (!this.isAuthenticated) {
                apiUrl += `&status=published`;
                console.log('[VacanciesLoader] Неавторизованный пользователь - загружаем только published');
            } else {
                console.log('[VacanciesLoader] Авторизованный пользователь - загружаем все вакансии');
            }
            console.log('[VacanciesLoader] API URL:', apiUrl);

            const response = await apiGet(apiUrl, { auth: false });
            console.log('[VacanciesLoader] Ответ получен:', response);

            let vacancyItems = Array.isArray(response) ? response : [];
            console.log('[VacanciesLoader] Количество вакансий от API:', vacancyItems.length);

            if (vacancyItems.length > 0) {
                await this.processVacanciesChunk(vacancyItems);

                this.currentOffset += vacancyItems.length;
                console.log(`[VacanciesLoader] Offset обновлен до: ${this.currentOffset}`);

                if (vacancyItems.length < this.itemsPerPage) {
                    console.log('[VacanciesLoader] Получено меньше вакансий чем запрашивали - это последний чанк');
                    this.hasMoreVacancies = false;
                    this.updateLoadMoreButton('no-more');
                } else {
                    this.updateLoadMoreButton('ready');
                }
            } else {
                if (offset === 0) {
                    console.log('[VacanciesLoader] Это был первый запрос - показываем пустое состояние');
                    this.renderEmptyState();
                }
                this.hasMoreVacancies = false;
                this.updateLoadMoreButton('no-more');
            }

            // Загружаем контент для всех блоков в контейнере
            loadContentForNewElements(this.container.querySelectorAll('[data-content]'));
        } catch (error) {
            console.error('[VacanciesLoader] Ошибка при загрузке чанка вакансий:', error);
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    async processVacanciesChunk(vacancyItems) {
        console.log(`[VacanciesLoader] processVacanciesChunk() - обрабатываем ${vacancyItems.length} вакансий`);

        for (let i = 0; i < vacancyItems.length; i++) {
            const vacancy = vacancyItems[i];
            console.log(`[VacanciesLoader] Обрабатываем вакансию: ${vacancy.slug}, статус: ${vacancy.status}`);

            const blockData = {
                id: vacancy.id,
                class_name: 'vacancy-block',
                data_block_name: vacancy.slug,
                order: this.currentOffset - vacancyItems.length + i
            };

            console.log(`[VacanciesLoader] Создаем блок для ${vacancy.slug}`);

            const blockElement = createAndTrackBlock(blockData, this.container);
            if (blockElement) {
                blockElement.setAttribute('data-vacancy-id', vacancy.id);
                blockElement.setAttribute('data-vacancy-status', vacancy.status || 'draft');
                blockElement.setAttribute('data-vacancy-slug', vacancy.slug);

                // ИСПРАВЛЕНО: Добавляем контролы статуса ТОЛЬКО для авторизованных И только на странице вакансий
                if (this.isAuthenticated && window.vacancyManager && vacancy.id) {
                    // Проверяем что мы на странице вакансий
                    if (window.location.pathname.match(/vacancies(\.html)?$/)) {
                        window.vacancyManager.addStatusControlsToBlock(blockElement, vacancy.id);
                        console.log(`[VacanciesLoader] Добавлены контролы статуса для ${vacancy.slug}`);
                    }
                } else if (!this.isAuthenticated) {
                    // Для неавторизованных удаляем индикаторы статуса
                    const statusIndicator = blockElement.querySelector('.vacancy-status-indicator');
                    if (statusIndicator) {
                        statusIndicator.remove();
                    }
                }

                // ИСПРАВЛЕНО: Обновляем ссылку для всех вакансий (и published и draft для админа)
                this.updateVacancyLink(blockElement, vacancy.slug, vacancy.status);
            } else {
                console.warn(`[VacanciesLoader] Не удалось создать блок для ${vacancy.slug}`);
            }
        }
    }

    updateVacancyLink(blockElement, vacancySlug, vacancyStatus) {
        const vacancyLink = blockElement.querySelector('a.news-link-to-feed-container');
        if (vacancyLink && vacancySlug) {
            // ИСПРАВЛЕНО: Для авторизованных всегда активная ссылка, для неавторизованных только если published
            const isActiveLink = this.isAuthenticated || vacancyStatus === 'published';
            const dynamicUrl = isActiveLink ? `/vacancy/${vacancySlug}` : '#';

            vacancyLink.href = dynamicUrl;
            vacancyLink.setAttribute('data-page', vacancySlug);
            vacancyLink.classList.toggle('active', isActiveLink);
            vacancyLink.classList.toggle('inactive', !isActiveLink);

            if (!isActiveLink) {
                vacancyLink.style.pointerEvents = 'none';
                vacancyLink.style.opacity = '0.5';
            } else {
                vacancyLink.style.pointerEvents = '';
                vacancyLink.style.opacity = '';
            }

            console.log(`[VacanciesLoader] Ссылка обновлена для ${vacancySlug}: ${dynamicUrl}, активная: ${isActiveLink}`);
        }
    }

    updateLoadMoreButton(state) {
        if (!this.loadMoreButton) return;

        switch (state) {
            case 'loading':
                this.loadMoreButton.textContent = 'завантажується...';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                break;

            case 'ready':
                this.loadMoreButton.textContent = 'завантажити більше';
                this.loadMoreButton.disabled = false;
                this.loadMoreButton.style.opacity = '1';
                this.loadMoreButton.style.display = 'block';
                break;

            case 'no-more':
                this.loadMoreButton.textContent = 'усі вакансії завантажено';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                setTimeout(() => {
                    if (this.loadMoreButton) {
                        this.loadMoreButton.style.display = 'none';
                    }
                }, 3000);
                break;
        }
    }

    showLoadMoreError() {
        if (this.loadMoreButton) {
            this.loadMoreButton.textContent = 'помилка завантаження';
            this.loadMoreButton.disabled = false;
            this.loadMoreButton.style.opacity = '1';

            setTimeout(() => {
                this.updateLoadMoreButton('ready');
            }, 3000);
        }
    }

    renderEmptyState() {
        console.log('[VacanciesLoader] renderEmptyState()');
        this.container.innerHTML = `
            <div class="vacancies-empty-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <h3>Вакансії скоро з'являться</h3>
                <p>Наразі немає активних вакансій</p>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    renderErrorState() {
        console.log('[VacanciesLoader] renderErrorState()');
        this.container.innerHTML = `
            <div class="vacancies-error-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <h3>Не вдалося завантажити вакансії</h3>
                <p>Спробуйте оновити сторінку</p>
                <button onclick="location.reload()" style="
                    padding: 10px 20px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-top: 10px;
                ">Оновити сторінку</button>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    async reload() {
        console.log('[VacanciesLoader] Перезагрузка вакансий');
        this.currentOffset = 0;
        this.hasMoreVacancies = true;
        this.clearContainer();
        await this.loadInitialVacancies();
    }
}

export const vacanciesLoader = new VacanciesLoader();